import { ApiUrl, AuthorizationHeaders } from '../api/environment';
export default function downloadFile(downloadUrl) {
    return fetch(`${ApiUrl}${downloadUrl}`, {
        method: 'GET',
        headers: AuthorizationHeaders(),
    }).then((res) => {
        var _a, _b;
        const fileName = (_b = (_a = res.headers.get('Content-Disposition')) === null || _a === void 0 ? void 0 : _a.split('filename=')[1]) !== null && _b !== void 0 ? _b : 'unnamed.xlsx';
        return res.blob().then((blob) => {
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(url);
        });
    });
}
